import { getBaseThemeProps, getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import Button from 'components/Button';
import { getButtonTheme } from 'components/Button/styled';
import Typography from 'components/Typography';
import { COMPONENTS_NAMES } from 'theme/constants';

const prefix = ['components', COMPONENTS_NAMES.FILTERS];

export const StyledButton = styled(Button)<{ $enableShowFocus: boolean }>`
  min-height: 32px;
  min-width: 36px;
  ${getButtonTheme([...prefix, 'operationButton'])}

  &:focus${({ $enableShowFocus }) => !$enableShowFocus && '-visible'} {
    ${getBaseThemeProps([...prefix, 'operationButton', 'pressed'])};

    background: ${getPrefixedVar(prefix, 'operationButton', 'pressed', 'bg')};
  }
`;

/* Sizes to the widest option so longer localized operator names (uk: "Більше або
   дорівнює") fit, with 180px as the floor so short EN names keep the old width. */
export const OperationsList = styled.div`
  min-width: 230px;
  width: max-content;
  max-width: 320px;
  padding: 8px 0;
`;

const operationPrefix = [...prefix, 'operationItem'];

export const OperationName = styled(Typography)`
  word-break: normal;
  overflow-wrap: break-word;
`;

export const Operation = styled.div<{
  $isSelected: boolean;
  $variant?: 'column' | 'sidebar';
}>`
  min-height: 28px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 12px;
  background: ${getPrefixedVar(operationPrefix, 'base', 'bg')};
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${getPrefixedVar(operationPrefix, 'base', 'text')};

  ${({ $isSelected, $variant }) => {
    if ($variant === 'column') {
      return;
    }

    return css`
      &:hover {
        background: ${getPrefixedVar(operationPrefix, 'hover', 'bg')};
        color: ${getPrefixedVar(operationPrefix, 'hover', 'text')};
      }

      &:active {
        background: ${getPrefixedVar(operationPrefix, 'pressed', 'bg')};
        color: ${getPrefixedVar(operationPrefix, 'pressed', 'text')};
      }

      ${$isSelected &&
      css`
        background: ${getPrefixedVar(operationPrefix, 'active', 'bg')};
        color: ${getPrefixedVar(operationPrefix, 'active', 'text')};
      `}
    `;
  }}
`;

export const OperationInfo = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  column-gap: 12px;
`;

export const IconContainer = styled.div`
  max-width: 17px;
  height: 17px;

  svg {
    width: 100%;
    height: 100%;
  }
`;
